import React from "react";
import PropTypes from "prop-types";
import calenderIcon from "../../../src/assets/images/result_calender_dashboard.svg";

const NextTestNotice = ({ test_type, timeLeft, isVitaminB12Flag, vitabinB12reportPublishedDate, timeLeftvitamin}) => {
  if (
    !(
      test_type === "boots-blood-vitamin-b12" ||
      test_type === "blood-vitamin-b12"
    )
  )
    return null;

  let timeMessage = "";
  if(timeLeft === null){
    timeLeft = timeLeftvitamin;
  }
  if (timeLeft?.months > 0) {
    timeMessage = `${timeLeft?.months} month${timeLeft?.months > 1 ? "s" : ""}`;
  } else {
    timeMessage = `${timeLeft?.weeks} week${timeLeft?.weeks > 1 ? "s" : ""}`;
  }
  return (
    <div className="next-test d-flex align-items-center p-3 w-100">
      <div className="icon-calendar me-3">
        <img src={calenderIcon} alt="Calendar" />
      </div>
      <div className="next-test-text">
        {timeLeft?.months === 0 && timeLeft?.weeks === 0 ? (
          <b>Your next Vitamin B12 blood test is due now.</b>
        ) : (
          <b className="text-width">
            Your next Vitamin B12 blood test is due in{" "}{timeMessage !== undefined && <span className="text-teal fw-bold">{timeMessage}</span>}
            
          </b>
        )}
      </div>
    </div>
  );
};

NextTestNotice.propTypes = {
  test_type: PropTypes.string.isRequired,
  timeLeft: PropTypes.shape({
    months: PropTypes.number,
    weeks: PropTypes.number,
  }),
  isVitaminB12Flag: PropTypes.bool,
  vitabinB12reportPublishedDate: PropTypes.string,
  timeLeftvitamin: PropTypes.shape({
    months: PropTypes.number,
    weeks: PropTypes.number,
  }),
};

export default NextTestNotice;
